import { Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";

import Loader from "../../../components/layout/Loader";
import hocFrom from "../../../components/forms/HocFrom";
import InputControl from "../../../components/inputs/InputControl";
import InputControlAsync from "../../../components/inputs/InputControlAsync";
import InputPricing from "../../../components/inputs/InputPricing";

const FormWarranty = ({ handelUpdataFrom,
    handelSend, loding, handelLoadingform, LoadingForm,
    dataUpdate, handelsetdataForm, formdata }) => {

    const handelValue = (name, value) => {
        handelsetdataForm({ ...formdata, [name]: value })
    }

    const handelSubmit = (event) => {
        event.preventDefault()

        handelLoadingform(true)
        if (formdata.workerId === undefined) {
            toast.error("لطفا نیرو را انتخاب کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.warrantyType === undefined) {
            toast.error("لطفا نوع ضمانت را انتخاب کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.amount === undefined) {
            toast.error("لطفا مبلغ را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else if (formdata.description === undefined) {
            toast.error("لطفا توضیحات را وارد کنید", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handelLoadingform(false)
        }
        else {
            dataUpdate.warrantyType ? handelUpdataFrom() : handelSend()
        }
    }

    return (
        <>
            {
                loding ?
                    <Loader />
                    : <Form method='post'  >
                        <Form.Row>
                            <Col>
                                <InputControlAsync url='/worker/search' name='workerId' label='نیرو' handelValue={handelValue} />
                            </Col>
                            <Col>
                                <InputControl url='/common/warrantytypedropdown' label='نوع ضمانت' name='warrantyType' handelValue={handelValue} />
                            </Col>
                            <Col>
                                <InputPricing handelValue={handelValue} name='amount' label='مبلغ' />
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col lg='12' md='12' sm='12' xs='12' >
                                <div className="form-group">
                                    <label htmlFor="descriptionTextarea">توضیحات</label>
                                    <textarea className="form-control" id="descriptionTextarea" rows="6" onChange={(e) => handelValue('description', e.target.value)} ></textarea>
                                </div>
                            </Col>
                        </Form.Row>
                        <Form.Row>
                            <Col>
                                <button type='submit'
                                    className='btn btn-success'
                                    onClick={handelSubmit}
                                    disabled={LoadingForm} >
                                    {LoadingForm ?
                                        <i className="fa fa-spinner fa-pulse fa-fw"></i>
                                        : dataUpdate.amount ? "ثبت ویرایش" : "ثبت"}
                                </button>
                            </Col>
                        </Form.Row>
                    </Form>
            }
        </>
    );
}

export default hocFrom(FormWarranty);
